import type { Operation } from './types';

export const DEFAULT_HOOKS: Operation[] = ['activate', 'mount'];



// WEBPACK FOOTER //
// ../../src/constants.ts